import { lazy } from "react";

// 마이페이지
const SeeMore = lazy(() => import("../pages/mypage/SeeMore"));
const IntegratedNotifications = lazy(
  () => import("../pages/mypage/integratedNotifications/IntegratedNotifications"),
);
const MyCredits = lazy(() => import("../pages/mypage/MyCredits"));
const MyBenefits = lazy(() => import("../pages/mypage/MyBenefits"));
const CouponList = lazy(() => import("../pages/mypage/CouponList"));
const MyReview = lazy(() => import("../pages/mypage/MyReview"));

// 내 정보 수정
const MyInfo = lazy(() => import("../pages/mypage/myInfo/MyInfo"));
const MyMate = lazy(() => import("../pages/mypage/myInfo/MyMate"));
const MyNick = lazy(() => import("../pages/mypage/myInfo/MyNick"));
const MyName = lazy(() => import("../pages/mypage/myInfo/MyName"));
const MyPassword = lazy(() => import("../pages/mypage/myInfo/MyPassword"));
const MyTel = lazy(() => import("../pages/mypage/myInfo/MyTel"));
const PushSetting = lazy(() => import("../pages/mypage/myInfo/PushSetting"));

// 예약 내역
const MyReservation = lazy(() => import("../pages/mypage/myReservation/MyReservation")); // 예약 내역
const MyReservationDetail = lazy(() => import("../pages/mypage/myReservation/MyReservationDetail")); // 예약 내역 상세
const HallReservationDetail = lazy(() => import("../pages/mypage/HallReservationDetail"));

// 찜 리스트 - 기존 주소도 병용
const MyInterest = lazy(() => import("../pages/mypage/MyInterest"));

// 최근 본 내역
const MyRecent = lazy(() => import("../pages/MyRecent"));

// 포인트 적립방법
const EarnPoint = lazy(() => import("../pages/mypage/EarnPoint"));

// MY내역
const MyRecords = lazy(() => import("../pages/mypage/myReservation/MyRecords"));

export const mypageRoutes = [
  { path: "/mypage", element: <SeeMore /> },
  { path: "/mypage/integrated-notifications", element: <IntegratedNotifications /> },
  { path: "/mypage/my-point", element: <MyCredits /> },
  { path: "/mypage/my-cash", element: <MyCredits /> },
  { path: "/mypage/my-benefits", element: <MyBenefits /> },
  { path: "/mypage/coupon-list", element: <CouponList /> },
  { path: "/mypage/review", element: <MyReview /> },

  { path: "/mypage/my-info", element: <MyInfo /> },
  { path: "/mypage/my-mate", element: <MyMate /> },
  { path: "/mypage/my-nick", element: <MyNick /> },
  { path: "/mypage/my-name", element: <MyName /> },
  { path: "/mypage/my-password", element: <MyPassword /> },
  { path: "/mypage/my-tel", element: <MyTel /> },
  { path: "/mypage/push-setting", element: <PushSetting /> },

  { path: "/my-reservation/:categoryType", element: <MyReservation /> },
  {
    path: "/my-reservation/:categoryType/detail/:reservationUuid",
    element: <MyReservationDetail />,
  },
  { path: "/mypage/hall-reservation-detail/:contractUuid", element: <HallReservationDetail /> },

  { path: "/my-interest/like", element: <MyInterest /> },
  { path: "/my-interest/like/:categoryType", element: <MyInterest /> },

  { path: "/my-interest/recent", element: <MyRecent /> },
  { path: "/how-to-earn-point", element: <EarnPoint /> },

  //웨딩홀 MY내역 추가
  { path: "/my-records/:categoryType", element: <MyRecords /> },
];
